export default "__VITE_ASSET__ByocrPpu__"